export enum HourStatus {
  AVAILABLE = 0 as const,
  SCHEDULED = 1 as const,
  UNAVAILABLE = 2 as const
}
